import React, { Component } from 'react';
import './App.css';
import { Grid, Divider, Header, Image } from '../node_modules/semantic-ui-react';
import Section from './components/Section'; 
import ReactGA from 'react-ga';

import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";

export default class App extends Component {
  state = { activeItem: 'home' }

  componentDidMount() {
    ReactGA.initialize('UA-116654863-1');
    ReactGA.pageview(window.location.pathname);
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/">
            <div id="homepage">
                <Grid>
                  <Grid.Column width={6} textAlign='right'>
                  <div id="column-left">
                    <p>
                      <Header as='h2'>
                        Kyung Je Jo
                      </Header>
                    </p>
                    <p style={{display: 'inline-block'}}>
                    <Image 
                      floated='right'
                      src={'https://s3.us-east-2.amazonaws.com/www.kyungjejo.com/img/profile.jpg'}
                      size='small'/>
                    </p>
                    <div className="info" id="contacts">
                      <Header as="h5">Contacts:</Header>
                      <a href="mailto:kyungjejo@kaist.ac.kr"><i className="mail big icon"></i></a>
                      <a href="https://github.com/kyungjejo/"><i className="github big icon"></i></a>
                      <a href="https://www.facebook.com/kyungje.k.jo"><i className="facebook big icon"></i></a>
                    </div>
                    {/* <div className="info">
                    <Header as="h5">Last Updated:</Header>
                      <p>2019.05.12</p>
                    </div> */}
                  </div>
                  </Grid.Column>
                  <Divider vertical/>
                  <Grid.Column width={10}>
                    <div className='sections'>
                        <Section sectionId='aboutMe' />
                        <Section sectionId='publications' />
                        <Section sectionId='awards' />
                        <Section sectionId='research' />
                        <Section sectionId='review' />
                        <Section sectionId='education' />
                    </div>
                  </Grid.Column>
                </Grid>
            </div>
          </Route>
          <Route exact path="/readings">
            <Section sectionId='readings' />
          </Route>
          <Route path="/reading/:id" >
            <Section {...this.props} sectionId='reading'/>
          </Route>
        </Switch>
    </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js